import styled from 'styled-components';

import Image from '../../UI/Image/Image';
import variables from '../../../styles/variables';

// GENERAL SCREEN STYLES
export const ErrorScreen = styled.div`
  width: 100%;
  height: auto;
  color: ${variables.colorBlack};
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
`;

export const BladeTitle = styled.h2`
  color: #eb0000;
  width: 100%;
  font-size: 43px;
  font-weight: 600;
  line-height: 40px;
  margin-bottom: 0;
  @media screen and (max-width: 768px) {
    font-size: 30px;
  }
`;

export const BladeSubtitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  line-height: 1.6;
  margin-bottom: 20px;
  width: 75%;
  @media screen and (max-width: 768px) {
    font-size: 20px;
    width: 100%;
  }
`;

export const TryAgainButton = styled.button`
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.64px;
  min-width: 250px;
  height: 53px;
  cursor: pointer;
  border: none;
  background: ${variables.colorRed};
  color: ${variables.colorWhite};
  border-radius: 26px;
  box-shadow:
    0 2px 4px 0 rgba(53, 43, 43, 0.24),
    0 2px 4px 0 rgba(238, 46, 36, 0.49);
  margin: 5px;
  transition: all 0.3s;
  &:hover {
    background: ${variables.colorWhite};
    color: ${variables.colorRed};
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  }
  @media screen and (max-width: 768px) {
    width: 60%;
  }
`;

export const SectionWrapper = styled.div`
  padding: 30px 0;
  &#tryAgainButton {
    @media screen and (max-width: 768px) {
      text-align: center;
    }
  }
`;

// IMAGE STYLES
export const ImgWrapper = styled.div`
  width: 50%;
  height: auto;
  margin-bottom: 20px;
`;

export const RobotImg = styled(Image)`
  width: 100%;
  height: auto;
`;
